import React from "react"

const FooterList = () => {
  return (
    <section className="footer-list">
      <div>
        <h3 className="footer-list-title">DigiWall</h3>
        <ul>
          <li>Get started</li>
          <li>Payment providers</li>
          <li>Product features</li>
          <li>Documentation</li>
        </ul>
      </div>

      <div>
        <h3 className="footer-list-title">Social</h3>
        <ul>
          <li>LinkedIn</li>
          <li>Instagram</li>
          <li>Twitter</li>
          <li>Facebook</li>
        </ul>
      </div>

      <div>
        <h3 className="footer-list-title">Corporate</h3>
        <ul>
          <li>About us</li>
          <li>Careers</li>
          <li>Press</li>
        </ul>
      </div>

      <div>
        <h3 className="footer-list-title">Supplement</h3>
        <ul>
          <li>Privacy policy</li>
          <li>Legal support</li>
          <li>Terms of use</li>
        </ul>
      </div>

      <div>
        <h3 className="footer-list-title">Contact</h3>
        <ul>
          <li>+852 2555 3000</li>
          <li>support@digiwall.co</li>
        </ul>
      </div>
    </section>
  )
}

export default FooterList
